module.exports = __webpack_public_path__ + "b0aa1fd7.png";